var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1270,
    viewBox: "0 0 2500 1270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.241 193V210.404V216.546V265.175H580.55V282.067V288.721V499.274H602.535V516.506H663V624H265V264.449H333.868V193H588.241Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1258.12 213V218.792H1262.01V270.919V280.092H1267V291.351V624H973V501.687H1027.59V213H1258.12Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1502.68 193V511.696H1521V559.504H1491.49V624H1267.61V315.338V296.911V280.019H1262.52V218.606H1258.96V212.812H1255V193H1502.68Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1739 193V263.885H1729.82V277.855H1719.71V504.506H1723.77V559H1521.27V511.461H1503V498.682V193H1739Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 13,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2201 194V734H2011.12H1987.7H1895.56V623.545H1852.8H1831.42H1808V613.318V600.534V549.398H1824.63V500.818H1951.88V266.685H1948.06V194H2201Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 11,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1737 624V963.004H1716.7V984H1497V736.529H1548.69V624H1737Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 10,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1548 624V736.66H1496.19V984H1279.99V943.327V932.791H1267V624H1548Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1266.32 624V932.344H1279V987.059V998.382V1052H1060.43H1046.74H1036.09V746.213H1030V733.94H973V624H1266.32Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M972.976 675V734.687H1030.85V746.931H1037V1052H1026.76H1015.49H806V675H972.976Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M806 675V1052H580V748.149H602.803V732.291H663.25V675H806Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M663 624V665.53V673.075V731.371H602.441V747.443H579.532V1052H334.282V989.176H265V624H663Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M818 213H588.705V265.664H581V499.328H602.822V516.712H663.214V575H797.193V566.308H816.985V501.373H798.715V269.754H818V213Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: 12,
    d: "M1894.68 624H1736.42V962.41H1716V1035H2201V734.418H1894.68V624Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor4);
export default __webpack_public_path__ + "static/media/select-floor-4.69d0c61c.svg";
export { ForwardRef as ReactComponent };